export default "__VITE_PUBLIC_ASSET__7dbde969__"